import React from "react"
import ReactDOM from "react-dom/client"
import "bootstrap/dist/css/bootstrap.min.css"
import { Provider } from "react-redux"
import { store } from "./app/store"
import App from "./App"
import "./index.css"
import { globalToastStyle, progressStyle } from "./toastStyles";

import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from "react-toastify"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer
        toastStyle={globalToastStyle}
        autoClose={1500}
        progressStyle={progressStyle}
        closeButton={true}
      />
      <App />
    </Provider>
  </React.StrictMode>,
)
